const filterGroups = {
  'filter-groups-breadcrumbs': 'Группы фильтров',
  'filter-groups-structured-type-field': 'Структурированный тип',
  'filter-groups-form-filters-field': 'Фильтры',
  'filter-groups-form-filters-hint': 'Поле заполняется существующими фильтрами',
  'filter-groups-form-filters-placeholder': 'Выберите фильтры',
  'filter-groups-filters-priority': 'Приоритет фильтров',
  'filter-groups-filters-priority-help': 'Установить желаемый порядок фильтров',
  'filter-groups-filters-not-selected': 'Фильтры еще не выбраны',
  'filters-filter-group-title': 'Группа фильтров',
  'filters-attached-to-collections': 'Невозможно удалить группу фильтров, так как она используется в коллекциях: ',
};

export default filterGroups;
